import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Accounting = () => {
  return (
    <div className="space-y-6">
      {/* Page header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Accounting</h1>
        <p className="text-sm text-gray-600 mt-1">
          Accounting tools and reports
        </p>
      </div>

      {/* Quick Access Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link
          to="/accounting/manual-commission-reporting"
          className="card hover:shadow-lg transition-shadow duration-200 cursor-pointer group"
        >
          <div className="flex items-center space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                <FileText className="h-6 w-6 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                Manual Commission Reporting
              </h3>
              <p className="text-sm text-gray-600">
                Manage and review manual commission reports
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Accounting;
